import React from 'react';
import {
    Box, Divider, IconButton, Popover, Typography
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { HelpOutlineRounded } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { COLORS } from '../../utils';

const styles = () => ({
    attentionButton: {
        color: COLORS.redColor,
        padding: '5px',
        alignItems: 'start',
    },
    button: {
        padding: '5px',
        alignItems: 'start',
    },
    inputWrapper: {
        display: 'flex',
        alignItems: 'flex-end'
    },
    attentionPopover: {
        '& .MuiPopover-paper': {
            overflow: 'inherit',
            backgroundColor: COLORS.lightRedColor,
        }
    },
    popover: {
        '& .MuiPopover-paper': {
            overflow: 'inherit',
            backgroundColor: COLORS.popoverColor,
        }
    },
    textColor: {
        color: COLORS.whiteGreyColor
    },
    title: {
        fontWeight: 600,
        color: COLORS.whiteGreyColor
    },
    divider: {
        backgroundColor: COLORS.whiteGreyColor
    },
    descriptionBox: {
        width: '50vh',
        zIndex: 1301,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',

        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 12,
            width: 10,
            height: 10,
            backgroundColor: COLORS.popoverColor,
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0
        }
    },
    attentionDescriptionBox: {
        width: '50vh',
        zIndex: 1301,
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',

        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 12,
            width: 10,
            height: 10,
            backgroundColor: COLORS.lightRedColor,
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0
        }
    }
});

const InfoTooltip = ({ classes, titleId, descriptionId, handleMouseLeave = () => {}, attention, t }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = event => {
        if (anchorEl) {
            handleMouseLeave();
            setAnchorEl(null);
        } else {
            setAnchorEl(event.currentTarget);
        }

    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const isStringDesc = typeof descriptionId === 'string';

    return (
        <>
            <IconButton
                aria-describedby={id}
                type="button"
                className={attention ? classes.attentionButton : classes.button}
                onClick={handleClick}
                size="large"
            >
                <HelpOutlineRounded />
            </IconButton>
            <Popover
                id={id}
                anchorEl={anchorEl}
                onClose={handleClick}
                className={attention ? classes.attentionPopover : classes.popover}
                open={open}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right'
                }}
            >
                <Box
                    p={2}
                    className={attention ? classes.attentionDescriptionBox : classes.descriptionBox}
                >
                    <Typography className={`${classes.title} ${classes.textColor}`}>
                        {t(titleId)}
                    </Typography>
                    <Divider className={classes.divider} />
                    <Typography className={classes.textColor}>
                        {isStringDesc ? t(descriptionId) : t(descriptionId.id, { name: descriptionId.name })}
                    </Typography>
                </Box>
            </Popover>
        </>
    );
};

InfoTooltip.propTypes = {
    classes: PropTypes.object.isRequired,
    titleId: PropTypes.string.isRequired,
    descriptionId: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
};

export default withStyles(styles)(InfoTooltip);
